import { Component, OnInit } from '@angular/core';
import '../../../assets/js/cloudCoverCircle.js';

declare var cloudCoverCircleHandler: any;
@Component({
    selector: 'app-cloud-cover-circle',
    templateUrl: './cloud-cover-circle.component.html',
    styleUrls: ['./cloud-cover-circle.component.css'],
    standalone: false
})
export class CloudCoverCircleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    cloudCoverCircleHandler.draw(110, 999);
  }

}
